import * as yup from 'yup';

export const schema = yup.object({
  termsAndConditions: yup
    .boolean()
    .required('Deben aceptarse los términos y condiciones.')
    .oneOf([true], 'Deben aceptarse los términos y condiciones.')
});

export { yupResolver } from '@hookform/resolvers/yup';
